var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferReviewComparisonGaugeUtility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 167,
    viewBox: "0 0 168 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "offer_review_gauge_utility_fill",
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#767676",
    stopOpacity: 0.490196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#808080",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.1072,
    cy: 83.0877,
    r: 83.0877,
    fill: "url(#offer_review_gauge_utility_fill)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00050354 83.0877C0.00050354 128.976 37.4283 166.175 83.5979 166.175C129.767 166.175 167.195 128.976 167.195 83.0877C167.195 37.1996 129.767 0 83.5979 0C37.4283 0 0.00050354 37.1996 0.00050354 83.0877ZM163.015 83.0877C163.015 126.681 127.459 162.021 83.5979 162.021C39.7368 162.021 4.18037 126.681 4.18037 83.0877C4.18037 39.494 39.7368 4.15438 83.5979 4.15438C127.459 4.15438 163.015 39.494 163.015 83.0877Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferReviewComparisonGaugeUtility);
export default __webpack_public_path__ + "static/media/offer-review-comparison-gauge-utility.110d82dedc384e0968b13f72033fd2f8.svg";
export { ForwardRef as ReactComponent };